import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { SciFiBackground } from './SciFiBackground';
import { useTheme } from '../../contexts/ThemeContext';
import { useTheaterMode } from '../../contexts/TheaterModeContext';
import branding from '../../branding.json';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { darkMode } = useTheme();
  const { theater } = useTheaterMode();

  // Determine which background to use based on branding settings
  const backgroundStyle = branding.theme?.background?.style || 'default';

  // TH-3a — Theater Mode reclaims the viewport: drop the app chrome (Header/Footer)
  // and the main column's max-width + padding so the trail surface goes full-bleed.
  // Keep the flex-1 min-h-0 overflow chain intact (one miss leaks unbounded growth).
  const mainCls = theater
    ? 'w-full flex-1 min-h-0 overflow-y-auto overflow-x-hidden relative z-10 flex flex-col'
    : 'max-w-[1800px] w-full mx-auto px-4 py-3 flex-1 min-h-0 overflow-y-auto overflow-x-hidden relative z-10 flex flex-col';

  return (
    <div className={`flex flex-col h-screen ${darkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'} transition-colors duration-200 relative`}>
      {/* Only render SciFiBackground if style is set to scifi */}
      {backgroundStyle === 'scifi' && <SciFiBackground />}

      {!theater && <Header />}
      <main className={mainCls}>
        {children}
      </main>
      {!theater && <Footer />}
    </div>
  );
};
